<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <form class="formGroup container halfForm">
      <div class="pageTitle">
        {{ "templatesRules.titleList" | translate }}
      </div>
      <div class="containerMasterTable">
        <div class="row shortRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label>Tipo de documento</label>
              </div>
            </div>
            <div class="inputContainer">
              <select
                [(ngModel)]="typeOfDocumentSelected"
                (change)="loadData(true)"
                name="typeOfDocument"
              >
                <option value="0">Selecciona una opción</option>
                <option
                  *ngFor="let typeOfDocument of typeOfDocumentList"
                  value="{{ typeOfDocument.tipoCertificado }}-{{
                    typeOfDocument.tipoReforma
                  }}-{{ typeOfDocument.descripcion }}"
                >
                  {{ typeOfDocument.tipoCertificado }}-{{
                    typeOfDocument.tipoReforma
                  }}-{{ typeOfDocument.descripcion }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="filterTableContainer">
      <app-table
        *ngIf="typeOfDocumentSelected != '0'"
        [tableList]="tableList"
        [elementList]="documentList"
        [routing]="routing"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [filterParams]="filtersTableJSON"
        [options]="options"
        (valueFilterTable)="filterTable($event)"
        (elementsToRemove)="removeElements($event)"
        (moveUpDown)="moveUpDown($event)"
      ></app-table>
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
    </div>
  </div>
</div>
